import { Suspense } from 'react'
import { StaticSiteSwitcherFallback } from '@/components/layout/breadcrumbs/static-site/static-site-switcher/fallback'
import { StaticSiteSwitcherData } from '@/components/layout/breadcrumbs/static-site/static-site-switcher/switcher'

export const StaticSiteSwitcher = () => (
  <Suspense fallback={<StaticSiteSwitcherFallback />}>
    <StaticSiteSwitcherData />
  </Suspense>
)
